// Sentry init must run before any other lexsite module. Reads
// VITE_SENTRY_DSN / VITE_GIT_SHA / VITE_LEXIUN_ENV from the Vite
// environment. See ai-docs/sentry-integration-guide.md §3.
import "./sentry";

import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { SentryFallback } from "./components/SentryFallback";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={SentryFallback}>
    <App />
  </Sentry.ErrorBoundary>,
);
